import { FC } from 'react';

import { SvgProps } from '@rbilabs/universal-components';

import { nullNoop } from 'utils/noop';

export const PointsIcon: FC<React.PropsWithChildren<SvgProps>> = nullNoop;
